export default __webpack_public_path__ + "static/media/5805.e1fb45e8.png";